import _ from "lodash";
import $ from "jquery";

let API_URL = '';

class API {
    
     /**
     * Call the API end point
     * Return a promise once the API return the reponse.
     * 
     * @param {string} url - API End point
     * @param {object} data - Request object / Data
     * 
     * @return {Promise}
     */
    call(url, data) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: API_URL + url,
                method: 'post',
                data: data,
                error: () => { reject(); },
                success: (response) => {
                    resolve(response);
                }
            })
        });
    }
}

class ReportAPI extends API {

    /**
     * Maps to report/generate/task/task-by-resource
     * 
     * @param {string} dateFrom - Start date
     * @param {string} dateTo   - End date
     * @param {string} bindname - Bindname
     */
    getTaskByResource(dateFrom, dateTo, bindname) {
        
        let data = {
            dateFrom : dateFrom,
            dateTo   : dateTo,
            bindname : bindname
        }

        return this.call('report/generate/task/task-by-resource', data);
    }

    /**
     * Maps to report/generate/task/task-by-project
     * 
     * @param {string} dateFrom  - Start date
     * @param {string} dateTo    - End date
     * @param {int}    projectId - Project ID
     */
    getTaskByProject(dateFrom, dateTo, projectId) {

        let data = {
            dateFrom : dateFrom,
            dateTo   : dateTo,
            projectId : projectId
        }

        return this.call('report/generate/task/task-by-project', data);
    }
}

class UserAPI extends API {

    /**
     * Maps user/all
     */
    getAllUsers() {
        console.debug('#UserAPI@getAllUsers - Loading all users');
        return this.call('user/all', {});
    }

    /**
     * Maps user/list-active-users
     */
    getActiveUsers() {
        console.debug('#UserAPI@getActiveUsers - Loading all active users');
        return this.call('user/list-active-users', {});
    }
}

class ProjectAPI extends API {

    /**
     * Maps to project/list-active-projects
     */
    getActiveProjects() {
        console.debug('#ProjectAPI@getActiveProjects - Loading all active projects');
        return this.call('project/list-active-projects', {});
    }
}

class ApiCaller {

    constructor(url) {
        API_URL = url;

        this.project = new ProjectAPI();
        this.report  = new ReportAPI();
        this.user    = new UserAPI();
    }
}

module.exports = ApiCaller;